import { trackPromise } from "react-promise-tracker";
import ParametroSolicitudReporteCrediticio from "../Contenedores/InformacionCrediticia/ParametroSolicitudReporteCrediticio";
import ParametroDetalleArchivoDescargable from "../Contenedores/InformacionCrediticia/ParametroDetalleArchivoDescargable";
import ParametroArchivoDescargable from "../Contenedores/InformacionCrediticia/ParametroArchivoDescargable";

import { apiInformacionCrediticia } from "../Utils/RutasApi";
import Http from "./Http";

export async function ObtengaReporteCrediticio(
  parametro: ParametroSolicitudReporteCrediticio
) {
  const url = apiInformacionCrediticia.ObtengaReporteCrediticio;

  let resultado = await trackPromise(Http.post<any>(url, parametro));

  return resultado.data;
}

export async function ObtengaReporteCrediticioParaDescargar(
  parametro: ParametroSolicitudReporteCrediticio
) {
  const url = apiInformacionCrediticia.ObtengaReporteCrediticioParaDescargar;

  let resultado = await trackPromise(Http.post<any>(url, parametro));

  return resultado.data;
}

export async function ObtengaPeriodoArchivoDescargable() {
  const url =
    apiInformacionCrediticia.ObtengaPeriodosArchivosDescargablesPorEntidad;
  let resultado = await trackPromise(Http.get<any>(url));

  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };
  return resultado.data;
}
export async function ObtengaDetalleArchivoDescargable(
  parametro: ParametroDetalleArchivoDescargable
) {
  const url = apiInformacionCrediticia.ObtengaDetalleArchivoDescargable;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un al Obtener detalle", value: "-1" };
  return resultado.data;
}
export async function ObtengaArchivoDescargable(
  parametro: ParametroArchivoDescargable
) {
  try {
    const url = apiInformacionCrediticia.ObtengaArchivoDescargable;

    const resultado = await trackPromise(
      Http.post<any>(url, parametro, {
        responseType: "blob",
      })
    );

    return resultado.data;
  } catch (error) {
    console.error("Error al obtener el archivo:", error);
  }
}

export async function ObtengaFormatoArchivoComportamientoDePago() {
  const url =
    apiInformacionCrediticia.ObtengaFormatoArchivoComportamientoDePago;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return {
      key: "Ocurrio un al Obtener formato archivo descargable",
      value: "-1",
    };
  return resultado.data;
}

const ServicioInformacionCrediticia = {
  ObtengaReporteCrediticio,
  ObtengaReporteCrediticioParaDescargar,
  ObtengaPeriodoArchivoDescargable,
  ObtengaDetalleArchivoDescargable,
  ObtengaArchivoDescargable,
  ObtengaFormatoArchivoComportamientoDePago,
};

export default ServicioInformacionCrediticia;
